<mat-sidenav-container class="main-container">

  <mat-sidenav-content>
    <div class="main-content chart-boundary">
      <app-viewer></app-viewer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
